import { CellProps } from "react-table";
import TextCell from "src/components/tables/cells/TextCell";
import Toggle from "src/components/toggles/Toggle";
import { getFormattedDate } from "src/helpers/helpers";
import ActionsCell from "./ActionsCell";
import { CouponType } from "./coupons-types";

const useCouponsTableColumns = ({
  onDelete,
  handleCouponStatusChange,
}: {
  onDelete: (id: number) => void;
  handleCouponStatusChange: (couponId: number, status: boolean) => void;
}) => {
  return [
    {
      Header: "Coupon Code",
      accessor: "name",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Start and End date",
      accessor: "startDate",
      className: "min-w-[150px]",
      Cell: ({ value, row }: CellProps<CouponType>) => {
        const startDate = row.original.startDate;
        const endDate = row.original.endDate;
        return (
          <TextCell
            value={`${getFormattedDate(startDate)} to ${getFormattedDate(
              endDate
            )}`}
          />
        );
      },
    },
    {
      Header: "Discount",
      accessor: "discount",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Maximum Discount",
      accessor: "maxDiscount",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Status",
      accessor: "status",
      className: "min-w-[150px]",
      Cell: ({ value, row }: CellProps<CouponType>) => {
        return (
          <div className="flex justify-center">
            <Toggle
              checked={value}
              onToggle={(value) =>
                handleCouponStatusChange(row.original.id, value)
              }
              showToggleStatus
            />
          </div>
        );
      },
    },
    {
      Header: "Actions",
      accessor: "id",
      className: "min-w-[200px]",
      Cell: ({ value }: CellProps<CouponType>) => (
        <ActionsCell value={value} onDelete={() => onDelete(value)} />
      ),
    },
  ];
};

export default useCouponsTableColumns;
